import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { MASKED_PLACEHOLDER } from '../../constants';

const MongoDBSourceForm = ({ name, config, errors, onChange, isEdit }) => {
    const hasUri = config?.uri && config.uri.trim() !== '';
    const handleChange = (field, value) => {
        if (field === 'name') {
            onChange({ name: value, config });
            return;
        }
        const next = { ...config };
        if (field === 'uri') {
            next.uri = value;
            if (value) {
                next.host = next.port = next.database = next.username = next.password = '';
            }
        } else {
            next[field] = value;
            if (field !== 'uri') next.uri = '';
        }
        onChange({ name, config: next });
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
                fullWidth
                label="Tên hiển thị"
                required
                value={name}
                onChange={(e) => handleChange('name', e.target.value)}
                error={!!errors?.name}
                helperText={errors?.name}
                placeholder="Ví dụ: MongoDB Production"
            />
            <TextField
                fullWidth
                label="Connection URI (hoặc điền các trường bên dưới)"
                value={config?.uri || ''}
                onChange={(e) => handleChange('uri', e.target.value)}
                error={!!errors?.uri}
                helperText={errors?.uri}
                placeholder="mongodb://user:pass@host:27017/database"
            />
            <Typography variant="caption" color="text.secondary">
                Hoặc điền từng trường:
            </Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
                <TextField
                    label="Host"
                    value={config?.host ?? 'localhost'}
                    onChange={(e) => handleChange('host', e.target.value)}
                    disabled={!!hasUri}
                />
                <TextField
                    label="Port"
                    type="number"
                    value={config?.port ?? 27017}
                    onChange={(e) => handleChange('port', e.target.value)}
                    disabled={!!hasUri}
                />
            </Box>
            <TextField
                fullWidth
                label="Database"
                value={config?.database ?? ''}
                onChange={(e) => handleChange('database', e.target.value)}
                disabled={!!hasUri}
            />
            <TextField
                fullWidth
                label="Username"
                value={config?.username ?? config?.user ?? ''}
                onChange={(e) => handleChange('username', e.target.value)}
                disabled={!!hasUri}
            />
            <TextField
                fullWidth
                label="Password"
                type="password"
                autoComplete="new-password"
                value={config?.password === '***' || config?.password === MASKED_PLACEHOLDER ? '' : (config?.password ?? config?.passwd ?? '')}
                onChange={(e) => handleChange('password', e.target.value)}
                disabled={!!hasUri}
                placeholder={isEdit ? MASKED_PLACEHOLDER : ''}
                helperText={isEdit && 'Để trống nếu không đổi mật khẩu'}
            />
        </Box>
    );
};

export default MongoDBSourceForm;
